export function requireCatalogList(value) {
  if (!Array.isArray(value) || value.some(item =>
    !item || typeof item !== "object" ||
    typeof item.id !== "string" || !item.id.trim() ||
    typeof item.name !== "string" || !item.name.trim()
  )) {
    throw new Error("Сервер вернул некорректный список. Повторите загрузку.");
  }
  return value;
}
